import { Button, Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { colorTextSubtlest } from 'src/app/themes/primaryThemeDefault'
import pageNotFound from 'src/assets/images/page-not-found.png'
import { menuUrls } from '../../constants/menu.constants'
import './index.scss'

const PageNotFound = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <Flex vertical align='center' justify='center' style={{ height: '100%' }}>
      <img src={pageNotFound} alt='page_not_found_logo' style={{ width: '100%', height: 'auto', maxWidth: 1080 }} />
      <Flex vertical align='center'>
        <Typography.Title level={1} style={{ textAlign: 'center', lineHeight: '48px', fontSize: 36, marginBottom: 16 }}>
          {t('common:pageNotFound')}
        </Typography.Title>

        <Typography.Text
          type='secondary'
          style={{ textAlign: 'center', color: colorTextSubtlest, fontSize: 16, lineHeight: '22px' }}
        >
          {t('common:pageNotFoundMessage')}
        </Typography.Text>
        <Button className='back-home-button' style={{ marginTop: 60 }} onClick={() => navigate(menuUrls.home)}>
          {t('common:backToHome')}
        </Button>
      </Flex>
    </Flex>
  )
}

export default PageNotFound
